const NTP_DECIMALS = 9;

export function formatNtp(value, { unit = 'NTP' } = {}) {
  const raw = String(value ?? '0').trim().replace(',', '.');
  if (!/^-?\d+(\.\d+)?$/.test(raw)) {
    return `0.${'0'.repeat(NTP_DECIMALS)} ${unit}`;
  }
  const sign = raw.startsWith('-') ? '-' : '';
  const unsigned = sign ? raw.slice(1) : raw;
  const [intPartRaw, fracRaw = ''] = unsigned.split('.');
  const intPart = intPartRaw.replace(/^0+(?=\d)/, '') || '0';
  const frac = `${fracRaw}${'0'.repeat(NTP_DECIMALS)}`.slice(0, NTP_DECIMALS);
  return `${sign}${groupDigits(intPart)}.${groupDigits(frac)} ${unit}`;
}

function groupDigits(value) {
  const s = String(value || '0');
  if (s.length <= 3) return s;
  return s.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function formatInteger(value) {
  const numeric = Number(value ?? 0);
  return Number.isFinite(numeric) ? numeric.toLocaleString() : '0';
}

export function formatDate(value, language = 'ru') {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat(language, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Minsk',
  }).format(date);
}

export function shortId(value, head = 8, tail = 6) {
  const s = String(value ?? '').trim();
  if (s.length <= head + tail + 1) return s || '-';
  return `${s.slice(0, head)}...${s.slice(-tail)}`;
}

export function asText(value) {
  const s = String(value ?? '').trim();
  return s || '-';
}

export function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export function amountClass(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n === 0) return '';
  return n > 0 ? 'amount-positive' : 'amount-negative';
}
